import React, { useState } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import RequireAuth from "./Utils/RequireAuth";

import SignIn from "./Components/UserValidation/SignIn/SignIn";
import SignUp from "./Components/UserValidation/SignUp/SignUp";
import ForgotPassword from "./Components/UserValidation/ForgotPassword/ForgotPassword";
import CreateNewPassword from "./Components/UserValidation/CreateNewPassword/CreateNewPassword";
import OTP from "./Components/UserValidation/OTP/OTP";

// pages
import Dashboard from "./Components/SideBar_1/Dashboard";
import BusinessListings from "./Components/SideBar_2/BusinessListings";
import Vouchers from "./Components/SideBar_3/Vouchers";
import CouponsDashboard from "./Components/SideBar_4/CouponsDashboard";
import Coupons from "./Components/SideBar_4/Coupons";
import VoucherDetails from "./Components/SideBar_3/VoucherDetails";
import CouponsDetails from "./Components/SideBar_4/CouponsDetails";
import { Communication } from "./Components/SideBar_5/Communication";
import { MarketplaceSetup } from "./Components/SideBar_6/MarketplaceSetup";
import { UserAdministration } from "./Components/SideBar_7/UserAdministration";
import { CreateTemplate } from "./Components/SideBar_5/CreateTemplate";
import CreatePage from "./Components/SideBar_6/CreatePage";
import { EditTemplate } from "./Components/SideBar_5/EditTemplate";
import { ViewTemplate } from "./Components/SideBar_5/ViewTemplate";
import { BusinessListingNotify } from "./Components/SideBar_2/BusinessListingNotify";
import { ErrorPage } from "./Components/ErrorPage/ErrorPage";
import EditPage from "./Components/SideBar_6/EditPage";
import BusinessPreview from "./Components/SideBar_2/BusinessPreview";
import Loader from "./Components/Loader/Loader";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./Components/TermsAndConditions/TermsAndConditions";
import ViewPage from "./Components/SideBar_6/ViewPages";
import Transactions from "./Components/SideBar_3/Transactions";
import Toaster from "./Components/Toaster/Toaster";
import PromoteCampaignPage from "./Components/SideBar_8/PromoteCampaign/PromoteCampaignPage";
import EmailInvitePage from "./Components/SideBar_8/EmailInvite/EmailInvitePage";
import EditEmailAddress from "./Components/UserValidation/UserProfile/EditEmailAddress/EditEmailAddress";
import OtpEmail from "./Components/SideBar_6/otp-email";
import CustomerListings from "./Components/SideBar_9/CustomerListings";
import EventsListing from "./Components/SideBar_10/EventsListing";
import { EditEvent } from "./Components/SideBar_10/EditEvent";
import MyCoupons from "./Components/SideBar_4/MyCoupons";
import CreateCoupon from "./Components/SideBar_4/CreateCoupon";
import CreateBussiness from "./Components/SideBar_4/CreateBussiness";
import CloneCoupon from "./Components/SideBar_4/CloneCoupon";
import ViewCoupon from "./Components/SideBar_4/ViewCoupon";
import ViewBusiness from "./Components/SideBar_4/ViewBusiness";
import EditCoupon from "./Components/SideBar_4/EditCoupon";
import EditBusiness from "./Components/SideBar_4/EditBusiness";
import Messages from "./Components/SideBar_11/Messages";
function App() {
  const [status, setStatus] = useState("");

  const manageStatus = (val) => {
    let s = val;
    setStatus(s);
  };

  const PrivateRoutes = [
    {
      id: 1,
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      id: 13,
      path: "/dashboard/all-categories",
      element: <Dashboard />,
    },

    // business-listing
    {
      id: 2,
      path: "/business-listings/all-listings",
      element: <BusinessListings />,
    },
    {
      id: 3,
      path: "/business-listings/new-listings",
      element: <BusinessListings />,
    },
    {
      id: 4,
      path: "/business-listings/in-review-listings",
      element: <BusinessListings />,
    },
    {
      id: 5,
      path: "/business-listings/published-listings",
      element: <BusinessListings />,
    },
    {
      id: 6,
      path: "/business-listings/declined-listings",
      element: <BusinessListings />,
    },

    // vouchers
    {
      id: 7,
      path: "/vouchers/vouchers-dashboard",
      element: <Vouchers />,
    },
    {
      id: 8,
      path: "/vouchers/manage-vouchers",
      element: <Vouchers />,
    },
    {
      id: 35,
      path: "/vouchers/featured-vouchers",
      element: <Vouchers />,
    },

    // Coupons
    {
      id: 9,
      path: "/coupons/coupons-dashboard",
      element: <Coupons />,
    },
    {
      id: 10,
      path: "/coupons/manage-coupons",
      element: <Coupons />,
    },
    {
      id: 36,
      path: "/coupons/featured-coupons",
      element: <Coupons />,
    },
    {
      id: 41,
      path: "/coupons/my-coupons",
      element: <Coupons />,
    },
    {
      id: 43,
      path: "/coupons/my-coupons/create-coupon",
      element: <CreateCoupon />,
    },
    {
      id: 48,
      path: "/coupons/my-coupons/edit-coupon/:coupon_id",
      element: <EditCoupon />,
    },
    {
      id: 44,
      path: "/coupons/bussiness-listing/create-bussiness",
      element: <CreateBussiness />,
    },
    {
      id: 45,
      path: "/coupons/my-coupons/clone-coupon/:coupon_id",
      element: <CloneCoupon />,
    },
    {
      id: 46,
      path: "/coupons/my-coupons/view-coupon/:coupon_id",
      element: <ViewCoupon />,
    },

    {
      id: 42,
      path: "/coupons/bussiness-listing",
      element: <Coupons />,
    },
    {
      id: 47,
      path: "/coupons/bussiness-listing/view-business/:mb_id",
      element: <ViewBusiness />,
    },
    {
      id: 48,
      path: "/coupons/bussiness-listing/edit-business/:mb_id",
      element: <EditBusiness />,
    },

    // Messages
    { id: 11, path: "/messages/:id", element: <Messages /> },
    // VoucherDetails
    {
      id: 11,
      path: "/vouchers/voucherDetails/:slug",
      element: <VoucherDetails />,
    },
    // CouponsDetails
    {
      id: 12,
      path: "/coupons/couponsDetails/:slug",
      element: <CouponsDetails />,
    },
    // communications
    {
      id: 14,
      path: "/communications/manage-templates",
      element: <Communication />,
    },
    {
      id: 15,
      path: "/communications/bulk-notify",
      element: <Communication />,
    },
    {
      id: 23,
      path: "/communications/manage-templates/create-template",
      element: <CreateTemplate />,
    },
    // marketplace-setup
    {
      id: 16,
      path: "/marketplace-setup/home-page-setup",
      element: <MarketplaceSetup />,
    },
    {
      id: 17,
      path: "/marketplace-setup/pages",
      element: <MarketplaceSetup />,
    },
    {
      id: 24,
      path: "/marketplace-setup/pages/create-page",
      element: <CreatePage />,
    },

    {
      id: 18,
      path: "/marketplace-setup/categories",
      element: <MarketplaceSetup />,
    },
    {
      id: 19,
      path: "/marketplace-setup/privacy-policy",
      element: <MarketplaceSetup />,
    },
    {
      id: 20,
      path: "/marketplace-setup/terms-&-conditions",
      element: <MarketplaceSetup />,
    },
    {
      id: 21,
      path: "/marketplace-setup/profile",
      element: <MarketplaceSetup />,
    },
    {
      id: 22,
      path: "/communications/manage-templates/edit-template/:slug",
      element: <EditTemplate />,
    },
    {
      id: 23,
      path: "/communications/manage-templates/view-template/:slug",
      element: <ViewTemplate />,
    },
    {
      id: 24,
      path: "/business-listings/notify/:slug",
      element: <BusinessListingNotify />,
    },
    {
      id: 25,
      path: "/marketplace-setup/pages/edit-page/:slug",
      element: <EditPage />,
    },
    ,
    {
      id: 26,
      path: "/business-listings/preview/:slug",
      element: <BusinessPreview />,
    },
    {
      id: 27,
      path: "/loader",
      element: <Loader />,
    },
    {
      id: 28,
      path: "/marketplace-setup/pages/view-page/:slug",
      element: <ViewPage />,
    },
    {
      id: 29,
      path: "/vouchers/transactions",
      element: <Transactions />,
    },
    {
      id: 30,
      path: "/shop-local-ai/email-for-invite-business",
      element: <EmailInvitePage />,
    },
    {
      id: 31,
      path: "/shop-local-ai/promote-campaign",
      element: <PromoteCampaignPage />,
    },
    {
      id: 32,
      path: "/edit-email",
      element: <EditEmailAddress />,
    },
    {
      id: 33,
      path: "/otp/:type",
      element: <OtpEmail />,
    },
    {
      id: 34,
      path: "/business-listings/featured-listings",
      element: <BusinessListings />,
    },
    {
      id: 34,
      path: "/customer-list",
      element: <CustomerListings />,
    },
    // events list
    {
      id: 35,
      path: "/events-list/all-events",
      element: <EventsListing />,
    },
    {
      id: 36,
      path: "/events-list/new-events",
      element: <EventsListing />,
    },
    {
      id: 37,
      path: "/events-list/in-review-events",
      element: <EventsListing />,
    },
    {
      id: 38,
      path: "/events-list/published-events",
      element: <EventsListing />,
    },
    {
      id: 39,
      path: "/events-list/declined-events",
      element: <EventsListing />,
    },
    {
      id: 40,
      path: "/events-list/edit-event/:slug",
      element: <EditEvent />,
    },

    // UserAdministration
    // {
    //   id: 21,
    //   path: "/user-administration/manage_users",
    //   element: <UserAdministration />,
    // },
    // {
    //   id: 22,
    //   path: "/user_administration/login_history",
    //   element: <UserAdministration />,
    // },
  ];

  return (
    <>
      <Toaster />
      <div className="App">
        <Routes>
          <Route path="/" element={<SignIn status={status} />}></Route>
          <Route path="*" element={<ErrorPage />}></Route>
          <Route
            path="/signup"
            element={<SignUp Status={manageStatus} />}
          ></Route>
          <Route path="/forgot-password" element={<ForgotPassword />}></Route>
          <Route
            path="/create-new-password"
            element={<CreateNewPassword />}
          ></Route>
          <Route path="/otp" element={<OTP />}></Route>
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />}></Route>
          <Route
            path="/TermsAndConditions"
            element={<TermsAndConditions />}
          ></Route>

          {PrivateRoutes.map((r) => {
            return (
              <Route
                path={r.path}
                key={r.id}
                element={<RequireAuth>{r.element}</RequireAuth>}
              ></Route>
            );
          })}
          {/* <ForgotPassword  /> */}
        </Routes>
      </div>
    </>
  );
}

export default App;
